const RECENT_SEARCH_KEY = "recent_searches";

const RecentSearch = {
  bindEvents() {
    const recentSearches = RecentSearch.getRecentSearches();
    if (recentSearches.length) {
      const $list = $(".search__recent-list");
      $list.empty();
      recentSearches.forEach((item) => {
        const $li = $(
          `<li class="search__recent-item">
            <a href="/products?q=${encodeURIComponent(item.keyword)}" class="d-flex align-items-center">
              <span>${item.keyword}</span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" class="js-recent-search-remove" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.24">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C10.9891 1.5 12.8968 2.29018 14.3033 3.6967C15.7098 5.10322 16.5 7.01088 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9ZM11.2543 10.5C11.2543 10.3 11.1745 10.1083 11.0325 9.9675L10.0575 9L11.0325 8.0325C11.3266 7.73841 11.3266 7.26159 11.0325 6.9675C10.7384 6.67341 10.2616 6.67341 9.9675 6.9675L9 7.9425L8.0325 6.9675C7.73841 6.67341 7.26159 6.67341 6.9675 6.9675C6.67341 7.26159 6.67341 7.73841 6.9675 8.0325L7.9425 9L6.9675 9.9675C6.82552 10.1083 6.74565 10.3 6.74565 10.5C6.74565 10.7 6.82552 10.8917 6.9675 11.0325C7.10833 11.1745 7.30002 11.2543 7.5 11.2543C7.69998 11.2543 7.89167 11.1745 8.0325 11.0325L9 10.0575L9.9675 11.0325C10.1083 11.1745 10.3 11.2543 10.5 11.2543C10.7 11.2543 10.8917 11.1745 11.0325 11.0325C11.1745 10.8917 11.2543 10.7 11.2543 10.5Z"
                    fill="#212529"
                  />
                </g>
              </svg>
            </a>
          </li>`,
        );
        $list.append($li);
      });

      $(".search__recent-list--empty").hide();
      $list.show();
    } else {
      $(".search__recent-list--empty").show();
      $(".search__recent-list").hide();
    }

    $(".js-recent-search-remove").on("click", function (e) {
      e.preventDefault();
      const keyword = $(this).closest("li").find("span").text();
      RecentSearch.removeRecentSearch(keyword);
      $(this).closest("li").remove();

      if ($(".search__recent-list li").length === 0) {
        $(".search__recent-list--empty").show();
        $(".search__recent-list").hide();
      }
    });

    $(".js-recent-search-store").on("click", function (e) {
      e.preventDefault();
      const keyword = $('input[name="q"]').val().trim();
      RecentSearch.saveRecentSearch(keyword);
      window.location.href = $(this).closest("a").attr("href");
    });

    $(".js-recent-search-reset").on("click", function (e) {
      e.preventDefault();
      RecentSearch.removeAllRecentSearch();
      $(".search__recent-list--empty").show();
      $(".search__recent-list").hide();
    });
  },
  getRecentSearches() {
    try {
      const raw = localStorage.getItem(RECENT_SEARCH_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  },
  isValidKeyword(keyword) {
    const value = keyword.trim();
    if (value.length < 2) return false;
    if (/^\d+$/.test(value)) return false;
    if (/@/.test(value)) return false;
    return true;
  },
  saveRecentSearch(keyword) {
    if (!RecentSearch.isValidKeyword(keyword)) return;

    const list = RecentSearch.getRecentSearches().filter((item) => item.keyword !== keyword);
    list.unshift({
      keyword,
      lastUsedAt: Date.now(),
    });

    localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(list.slice(0, 10)));
  },
  removeRecentSearch(keyword) {
    const list = RecentSearch.getRecentSearches().filter((item) => item.keyword !== keyword);

    localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(list));
  },

  removeAllRecentSearch() {
    localStorage.removeItem(RECENT_SEARCH_KEY);
  },
};
